import { mapArrayElement } from "@draftkings/sportsbook-common-utils";
function buildCategories(categories) {
    return categories.map(data => ({
        id: data[0],
        name: data[2],
        tags: data[3],
        sortOrder: data[4]
    }));
}
function buildSubCategories(subCatgories) {
    return subCatgories.map(data => ({
        id: data[0],
        categoryId: data[1],
        name: data[2],
        componentId: data[3],
        sortOrder: data[4],
        tags: data[5],
    }));
}
export function mapCategories(data) {
    return mapArrayElement(data, buildCategories);
}
export function mapSubCategories(data) {
    return mapArrayElement(data, buildSubCategories);
}
//# sourceMappingURL=mapSportsbookCategories.js.map